import { router } from "..";
import { getFenceAlarm2 } from "../api/fencealarm2s_{imei}";
import { prices } from "../billing/prices";
import { deviceCard, formatSubscriptionStatus } from "../device/device_card";
import { relativeTimeString, t } from "../locale";
import { addNotificationListener } from "../mobile";
import { state } from "../state";
import { keyValueParagraph } from "../view/components";
import { Html } from "../view/html";
import { MaterialDesign } from "../view/material_design";
import { getFencealarm2Warnings } from "./fa2_warnings";

/**
 * @param {Fencealarm2} fa2
 */
async function fencealarm2Card(fa2) {
	addNotificationListener("fencealarm2", fa2.Imei, () => {
		getFenceAlarm2(fa2.Imei).then((fa2) => {
			state.fencealarm2s[fa2.Imei] = fa2;
		});
	});

	return deviceCard({
		deviceName: fa2.Metadata.Name,
		deviceType: "fencealarm2",
		productName: "FenceAlarm2",
		warnings: getFencealarm2Warnings(fa2),
		lines: [
			keyValueParagraph(t.device.card.statusLabel),
			keyValueParagraph(`- ${t.voltage}`, `${fa2.Voltage} V`),
			keyValueParagraph(
				`- ${t.fencealarm.alarmLevelLabel}`,
				`${fa2.PendingResponse_v0_3?.Config?.AlarmLevel && fa2.PendingResponse_v0_3.Config.AlarmLevel !== fa2.Config_v0_3.AlarmLevel ? "*" : ""} ${fa2.Config_v0_3.AlarmLevel} V`,
			),
			keyValueParagraph(
				`- ${t.lastActive}`,
				relativeTimeString(fa2.LastUplinkAt),
			),
			keyValueParagraph(t.device.subscriptionLabel),
			keyValueParagraph(
				`- ${t.device.card.planLabel}`,
				await formatSubscriptionPlan(fa2),
			),
			keyValueParagraph(...formatSubscriptionStatus(fa2.Subscription)),
		],
		buttons: [
			Html.anchor(
				{},
				MaterialDesign.icon({
					id: "monitoring",
					onClick: () => router.jump(`/fencealarm2/${fa2.Imei}/logs`),
				}),
			),
			Html.anchor(
				{},
				MaterialDesign.icon({
					id: "settings",
					onClick: () => router.jump(`/fencealarm2/${fa2.Imei}`),
				}),
			),
		],
	});
}

/**
 * @param {Fencealarm2} fa2
 */
async function formatSubscriptionPlan(fa2) {
	if (fa2.Subscription.Trialing) return t.trial;

	const {
		Fencealarm2Month: FenceAlarm2Month,
		Fencealarm2Year: FenceAlarm2Year,
	} = await prices;

	switch (fa2.Subscription.PriceIds.Current) {
		case FenceAlarm2Month.Id:
			return t.monthly;
		case FenceAlarm2Year.Id:
			return t.yearly;
	}

	const expiryTime = new Date(fa2.Subscription.ExpiresAt);
	if (Date.now() < expiryTime.getTime()) return "";

	return t.none;
}

export { fencealarm2Card };
